export default __webpack_public_path__ + "static/media/resume-2.121fb54f.png";